import type { Task } from './api';
import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from '@lingui/core';

/** A heartbeat is configured when there is reusable schedule or prompt state. */
export const isHeartbeatConfigured = (task: Task): boolean =>
  (task.heartbeat_interval_ms ?? 0) > 0;

/** Omitted is enabled for task payloads produced before the pause flag shipped. */
export const isHeartbeatEnabled = (task: Task): boolean =>
  isHeartbeatConfigured(task) && task.heartbeat_enabled !== false;

export interface HeartbeatIntervalOption {
  value: number;
  label: MessageDescriptor;
}

export const HEARTBEAT_INTERVAL_OPTIONS: HeartbeatIntervalOption[] = [
  { value: 5, label: msg`Every 5 minutes` },
  { value: 10, label: msg`Every 10 minutes` },
  { value: 15, label: msg`Every 15 minutes` },
  { value: 30, label: msg`Every 30 minutes` },
  { value: 60, label: msg`Every 1 hour` },
  { value: 120, label: msg`Every 2 hours` },
];

export const DEFAULT_HEARTBEAT_MINUTES = 5;

const STORAGE_KEY = 'borgee:tasks:heartbeatMinutes';

export const loadPreferredHeartbeatMinutes = (): number => {
  try {
    const stored = Number(localStorage.getItem(STORAGE_KEY));
    return HEARTBEAT_INTERVAL_OPTIONS.some(o => o.value === stored) ? stored : DEFAULT_HEARTBEAT_MINUTES;
  } catch {
    return DEFAULT_HEARTBEAT_MINUTES;
  }
};

export const rememberHeartbeatMinutes = (minutes: number): void => {
  try {
    localStorage.setItem(STORAGE_KEY, String(minutes));
  } catch {}
};
